import styled from 'styled-components';

export const StyledThumbnailsSidebar = styled.div`
  background: #fbfbfb;
  display: flex;
  flex-direction: column;
  padding: 1.5rem 2rem;
  height: calc(100% - 40px);
  left: ${props => (props.isOpened ? '0' : '-100vw')};
  overflow-y: auto;
  position: fixed;
  top: 40px;
  transition: 0.5s ease;
  width: 100vw;
  z-index: 2500;
`;

export const ThumbnailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
`;

export const StyledThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 24px;

  > img {
    display: flex;
    max-width: 120px;
    height: auto;
    cursor: pointer;
    border: 1px solid #dedede;
    font-size: 14.22px;
    box-shadow: ${props =>
      props.isActive ? '0px 0px 0px 3px #177dd6' : 'none'};
  }

  > span {
    text-align: center;
    color: #4f4f4f;
    margin-top: 0.5em;
    align-self: center;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: fit-content;

  > span {
    font-weight: 500;
    color: #4f4f4f;
  }

  > span:last-child {
    width: 32px;
  }
`;

export const StyledLine = styled.hr`
  width: 100%;
  border: 0.5px solid #c8c8c8;
  margin-bottom: 1.25em;
`;
